export enum CreditLimitPreferenceTypes {
	Automatically = 'automatically',
	CustomerApproved = 'customerapproved ',
}
